export const props = Object.freeze({
  /**
   * Question asked in a confirmation dialog before the form is sent. Cancel sends nothing. Leave it empty to send at once.
   *
   * @type {String}
   * @default undefined
   */
  confirm: {
    type: String,
    default: undefined,
  },
});
